import { render } from "./TheAdminHeader.vue?vue&type=template&id=a72526b6"
import script from "./TheAdminHeader.vue?vue&type=script&lang=js"
export * from "./TheAdminHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__